import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const formRef = useRef();
  const [status, setStatus] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus("Sending...");

    emailjs
      .sendForm(
        "service_7hy9f09",
        "template_dogerf4",
        formRef.current,
        "_b5dS6LG90oPaQ5jH"
      )
      .then(() => {
        setStatus("✅ Message Sent Successfully!");
        e.target.reset();
      })
      .catch((error) => {
        console.error("EmailJS Error:", error);
        setStatus("❌ Failed to send message. Please try again.");
      });
  };

  return (
    <div className="bg-white rounded-2xl shadow-md p-6 max-w-sm mx-auto mt-10">
      <h3 className="text-xl font-semibold mb-4 text-center">Contact Us</h3>

      <form ref={formRef} onSubmit={sendEmail} className="space-y-4">
        {/* Name */}
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          required
          className="block w-full p-3 border rounded-lg"
        />

        {/* Email */}
        <input
          type="email"
          name="email"
          placeholder="Your Email"
          required
          className="block w-full p-3 border rounded-lg"
        />

        {/* Subject */}
        <input
          type="text"
          name="subject"
          placeholder="Subject"
          required
          className="block w-full p-3 border rounded-lg bg-gray-50"
        />

        {/* Message */}
        <textarea
          name="message"
          rows="4"
          placeholder="Your Message"
          required
          className="block w-full p-3 border rounded-lg"
        ></textarea>

        {/* Send Button */}
      <button
  type="submit"
  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg w-full transition"
>
  Send Message
</button>

      </form>

      {status && (
        <p className="text-center text-sm mt-3 text-gray-700">{status}</p>
      )}
    </div>
  );
};

export default ContactForm;
